import { render, staticRenderFns } from "./DiscountCodes.vue?vue&type=template&id=765b6856&scoped=true&"
import script from "./DiscountCodes.vue?vue&type=script&lang=ts&"
export * from "./DiscountCodes.vue?vue&type=script&lang=ts&"
import style0 from "./DiscountCodes.vue?vue&type=style&index=0&id=765b6856&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765b6856",
  null
  
)

export default component.exports